export interface IComparisonConversion {
    centerId: number,
    centerAlias: string,
    hasFollowUp: boolean,
    isDcnCenter: boolean,
    isDsdCenter: boolean,
    isVoucherParticipant: boolean,
    isPlDashCenter: boolean,
    isMicrositeCenter: boolean,
    isInReferralNetwork: boolean,
    isExpertSystem: boolean,
    isMicrositeCenterOfExcellence: boolean,
    isDonorConnectEnabled: boolean,
    directedDonorCount: number,
    standardVoucherCount: number,
    nonDirectedDonorCount: number,
    familyVoucherCount: number,
    priorYearReferrals: number,
    reportYearReferrals: number,
    reportYearDonations: number,
    priorYearRegistrations: number,
    reportYearRegistrations: number,
    referralCount: number,
    donatedCountAnnualized: number,
    donatedCount: number,
    donatedNkrCount: number,
    donatedDirectCount: number,
    donatedDisconnectCount: number,
    registeredCountAnnualized: number,
    referredCountAnnualized: number,
    registeredCountAverage: number,
    referredCountAverage: number,
    referralConversionRate: number,
    referralConversionRatePercent: number,
    registrationConversionRate: number,
    registrationConversionRatePercent: number,
    nkrDonationRate: number,
    nkrDonationPercent: number,
    directDonationRate: number,
    directDonationPercent: number,
    disconnectRate: number,
    disconnectPercent: number,
    contactTimeDaysMedian: number,
    contactTimeDaysMedianPriorYear: number
}
